<template>
  <div class="DhHeroComponent" :style="[backgroundImageStyle]">
    <div class="dh-grid-container">
      <div class="dh-grid-text">We Help You To Connect<br/>With Your Customers</div>
    </div>
  </div>
</template>

<script>
  import bgImage from '../../assets/images/deal.jpg'

  export default {
    name: 'DhHero',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {
      backgroundImageStyle () {
        return {
          backgroundImage: `url(${this.bgImage})`
        }
      }
    },
    watch: {},
    mixins: [],
    data: function () {
      return {
        bgImage
      }
    },
    filters: {},
    methods: {},
    created: function () {
    },
    mounted: function () {
    },
    updated: function () {
    },
    destroyed: function () {
    }
  }
</script>

<style scoped>
  .DhHeroComponent {
    height: 80vh;
    width: 100%;
    background-size: cover;
    background-position: center;

    .dh-grid-container {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: auto;

      .dh-grid-text {
        /*justify-self: stretch;*/
        /*align-self: stretch;*/
        place-self: center;
        font-size: 50px;
        font-family: var(--font-display);
        color: white;
        text-shadow: 1px 1px 10px cornflowerblue;
        text-align: center;
      }
    }
  }
</style>
